import React from "react";
import UserRegistrationComponent from "./userRegistration.component";

const UserRegistrationContainer = () => {
  return <UserRegistrationComponent />;
};

export default UserRegistrationContainer;
